import { useEffect } from 'react';
import { Host } from './Hosts';
import HostClient from '../host/HostClient';

/**
 * Hook for interacting with the host enviroment
 *  pass through a function to update host state when a host event is emitted
 */
export function useHost(hostDispatchFunction?: (host: Host) => void) {
    useEffect(() => {
        triggerFunction();
        HostClient.on('host-changed', () => {
            console.log('host changed');
            triggerFunction();
        });
        return () => {
            HostClient.removeListener('host-changed', () => null);
        };
        //eslint-disable-next-line
    }, []);

    function triggerFunction() {
        if (hostDispatchFunction) {
            hostDispatchFunction(HostClient.host);
        }
    }

    return HostClient;
}
